import Model from '@/entities/Model.js';
import Contact from '@/entities/Contact.js';
import { getDate, getTime } from '@/utils/date.js';

export default class Appointment extends Model {
    static get defaults() {
        return {
            account_id: null,
            automation_id: null,
            contact_id: null,
            contact_phone_id: null,

            datetime: null,
            notes: null,
            related_vehicle_make: '',

            // Belongs to
            _contact: new Contact(),
        };
    }

    get contact() {
        return this._contact;
    }

    set contact(value) {
        if (value) {
            this._contact = new Contact(value);
            this.contact_id = value.id;
        }
    }

    get date() {
        return getDate(this.datetime);
    }

    set date(value) {
        const datetime = `${value} ${this.time}`.trim();
        this.datetime = moment(datetime).tz('UTC').format();
    }

    get time() {
        return getTime(this.datetime);
    }

    set time(value) {
        const datetime = `${this.date} ${value}`.trim();

        this.datetime = moment(datetime).tz('UTC').format();
    }

    isValid() {
        return !!this.contact_id && !!this.datetime;
    }
}
